import ClientCard from './ClientCard';

export default ClientCard;
